define('commons/table-of-content',['jquery'], function($) {
    var Toc = function(container, options) {

        this.settings = {
            selectors: 'h1,h2,h3,h4',
            scrollContainer: 'html,body',
            scrollOffset: 0,
            smoothScrolling: true,
            prefix: 'toc',
            activeClassName: 'toc-active',
            highlightOnScroll: true,
            anchorName: function(i, heading, prefix) {
                return prefix + i;
            }
        };

        $.extend(this.settings, options);

        this.$container = $(container);
        this.$scrollContainer = $(this.settings.scrollContainer);
        this.$win = $(window);
        this.headingOffsets = [];
        this.selected = null;
        this.lastOffset = 0;

        this.$scrollContainer.scrollTop(0);
        this.buildToc();

        if (this.settings.highlightOnScroll) {
            this.attach();
            this.highlightOnScroll();
        }

    };

    Toc.prototype.buildToc = function() {
        // build TOC
        this.$container.empty();
        this.$headings = $(this.settings.selectors);
        var ul = $('<ul/>');
        var count = 0;
        this.$headings.each($.proxy(function(i, heading) {
            var $h = $(heading);
            this.headingOffsets.push(Math.round($h.offset().top));
            var name = this.settings.anchorName(i, heading, this.settings.prefix);
            // add anchor
            $('<span/>').attr('id', name).insertBefore($h);
            // build TOC item
            var a = $('<a/>').text($h.text()).attr('href', '#' + name).bind('click', $.proxy(this.scrollTo, this));
            var li = $('<li/>').addClass(this.settings.prefix + '-' + heading.tagName.toLowerCase()).append(a);
            ul.append(li);
        }, this));
        this.$container.append(ul);
    };

    Toc.prototype.attach = function() {
        this.$win.bind('scroll', $.proxy(this.highlightOnScroll, this));
    };

    Toc.prototype.detach = function() {
        this.$win.unbind('scroll');
    };

    Toc.prototype.scrollTo = function(event) {
        event.preventDefault();
        var href = $(event.target).attr('href');
        var $el = $(href).next();
        this.select($(event.target).parent());
        var scrollTo = Math.round($el.offset().top - this.settings.scrollOffset);
        if (this.settings.smoothScrolling) {
            this.detach();
            this.$scrollContainer.animate({
                scrollTop: scrollTo
            }, {
                duration: 400,
                easing: 'swing',
                complete: $.proxy(this.attach, this)
            });
        } else {
            this.$scrollContainer.scrollTop(scrollTo);
        }
    };

    Toc.prototype.select = function(item) {
        if (this.selected === null || this.selected.get(0) != item.get(0)) {
            this.unSelect();
            item.addClass(this.settings.activeClassName);
            this.$win.trigger("v-slider-select", item);
            this.selected = item;
        }
    };

    Toc.prototype.unSelect = function() {
        if (this.selected !== null) {
            this.selected.removeClass(this.settings.activeClassName);
        }
    };

    Toc.prototype.highlightOnScroll = function(event) {
        var top = this.$win.scrollTop() + this.settings.scrollOffset;
        var pos = -1;
        var selectedOffset = -1;
        for (var i = 0; i < this.headingOffsets.length; i++) {
            var offset = this.headingOffsets[i];
            if (offset <= top) {
                pos = i;
                selectedOffset = this.headingOffsets[i];
                if (i != this.headingOffsets.length - 1) {
                    continue;
                }
            }
            if (pos == -1) {
                if (this.lastOffset !== 0) {
                    this.lastOffset = 0;
                    this.unSelect();
                }
            } else if (this.lastOffset != selectedOffset) {
                this.lastOffset = selectedOffset;
                this.select(this.$container.find('li:eq(' + pos + ')'));
            }
            break;
        }
    };

    return Toc;
});

